/**
 * Canadian Branding
 *
 * Small public badge linking to the Made in Canada page.
 *
 * Primary responsibilities:
 * - Surface Canadian positioning without overpowering page content
 * - Stay out of the way on smaller viewports
 *
 * Dependencies:
 * - framer-motion
 * - i18n
 */

'use client'

import Link from 'next/link'
import { motion } from 'framer-motion'
import { useTranslation } from 'react-i18next'

export default function CanadianBranding() {
  const { t } = useTranslation()
  return (
    <motion.div
      className="fixed bottom-3 right-3 z-40 hidden md:block"
      initial={{ x: 100, opacity: 0 }}
      animate={{ x: 0, opacity: 1 }}
      transition={{
        type: 'spring',
        stiffness: 300,
        damping: 25
      }}
    >
      <Link
        href="/made-in-canada"
        className="bg-white/88 dark:bg-zinc-900/82 group flex items-center gap-1.5 rounded-full border border-red-200/70 px-3 py-2 shadow-[0_12px_30px_rgba(15,23,42,0.08)] backdrop-blur-md transition-all duration-200 hover:-translate-y-px hover:bg-white hover:shadow-[0_16px_35px_rgba(15,23,42,0.12)] dark:border-red-900/60 dark:hover:bg-zinc-900"
      >
        <div className="relative size-4 shrink-0">
          <svg width="16" height="16" viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg">
            <path
              fill="#D52B1E"
              d="M4 5a4 4 0 0 0-4 4v18a4 4 0 0 0 4 4h6V5H4zm28 0h-6v26h6a4 4 0 0 0 4-4V9a4 4 0 0 0-4-4z"
            ></path>
            <path fill="#EEE" d="M10 5h16v26H10z"></path>
            <path
              fill="#D52B1E"
              d="M18.615 22.113c1.198.139 2.272.264 3.469.401l-.305-1.002a.46.46 0 0 1 .159-.476l3.479-2.834l-.72-.339c-.317-.113-.23-.292-.115-.722l.531-1.936l-2.021.427c-.197.03-.328-.095-.358-.215l-.261-.911l-1.598 1.794c-.227.288-.687.288-.544-.376l.683-3.634l-.917.475c-.257.144-.514.168-.657-.089l-1.265-2.366v.059v-.059l-1.265 2.366c-.144.257-.401.233-.658.089l-.916-.475l.683 3.634c.144.664-.317.664-.544.376l-1.598-1.793l-.26.911c-.03.12-.162.245-.359.215l-2.021-.427l.531 1.936c.113.43.201.609-.116.722l-.72.339l3.479 2.834c.138.107.208.3.158.476l-.305 1.002l3.47-.401c.106 0 .176.059.175.181l-.214 3.704h.956l-.213-3.704c.002-.123.071-.182.177-.182z"
            ></path>
          </svg>
        </div>
        <span className="text-[11px] font-medium uppercase tracking-[0.16em] text-gray-600 transition-colors duration-200 group-hover:text-red-600 dark:text-gray-300 dark:group-hover:text-red-400">
          {t('proudly-canadian')}
        </span>
      </Link>
    </motion.div>
  )
}
